import * as Yup from 'yup';
import { areaFormModel } from './areaFormModel';

const {
  formField: { name, description },
} = areaFormModel;

export const areaValidationSchema = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg).max(255, 'Máximo 255 caracteres'),
  [description.name]: Yup.string().nullable(),
});
